export default (props, {
  rhythm
}) => ({
  category: {
    paddingBottom: rhythm(1)
  }
})
